/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Eyes_TiInputs */

const en_funnel_ob_ben_eyes_ti = /** @type {(inputs: Funnel_Ob_Ben_Eyes_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your eyes a break. Just listen.`)
};

const es_funnel_ob_ben_eyes_ti = /** @type {(inputs: Funnel_Ob_Ben_Eyes_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dale un respiro a tus ojos. Solo escucha.`)
};

/**
* | output |
* | --- |
* | "Give your eyes a break. Just listen." |
*
* @param {Funnel_Ob_Ben_Eyes_TiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_eyes_ti = /** @type {((inputs?: Funnel_Ob_Ben_Eyes_TiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Eyes_TiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_eyes_ti(inputs)
	return en_funnel_ob_ben_eyes_ti(inputs)
});